module.exports = __webpack_public_path__ + "9f572c1cb8a6c0b18afbc7b819232b93.pdf";